import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import { RootState } from '../interfaces/rootState';
import { postWithAuthPayload } from '@/util/HTTPCommpix';
import { Balance } from '@/store/interfaces/commpix-api/balance';
import balanceType from '@/store/types/balance';

const namespaced = true;
const initialState = (): Balance => {
  return {
    amount: null,
    currency: null,
  };
};

const state: Balance = initialState();

const mutations: MutationTree<Balance> = {
  setBalance(state, balance) {
    state.amount = balance.amount;
    state.currency = balance.currency;
  },
};

const actions: ActionTree<Balance, RootState> = {
  [balanceType.actions.FETCH_BALANCE]: async ({ commit, }) => {
    return postWithAuthPayload('/payouts-balance')
      .then(response => {
        commit('setBalance', response.data);
      })
      .catch(error => {
        throw error;
      });
  },
};

const getters: GetterTree<Balance, RootState> = {
  [balanceType.getters.GET_BALANCE]: state => {
    return state;
  },
};

export const balance: Module<Balance, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};

export default balance;
